export default __webpack_public_path__ + "static/media/10.d09167e7.jpg";